/**************
 Search
 ***************/

// Show search form on click
document.querySelector("#headerSearchButton").addEventListener("click", function () {
    document.querySelector("#headerSearch").classList.toggle("open");
    document.querySelector("#headerSearchFormInput").focus();
});

// close search form on outside click
document.addEventListener("click", function (event) {
    if (!event.target.closest("#headerSearch") && !event.target.closest("#headerSearchButton")) {
        document.querySelector("#headerSearch").classList.remove("open");
    }
});

/*************
 Profile Switcher
 **************/

// check for profiles
if (document.querySelector("#headerB2BAccount") && localStorage.getItem("profiles")) {
    // show account selector
    document.querySelector("#headerB2BAccount").classList.add("active");

    // cache the selector elements we query repeatedly
    const accountToggle = document.querySelector("#headerB2BAccountToggle");
    const accountToggleText = document.querySelector("#headerB2BAccountToggleText");
    const accountDropdown = document.querySelector("#headerB2BAccountDropdown");
    const accountSearch = document.querySelector("#headerB2BAccountDropdownSearch");
    const accountList = document.querySelector("#headerB2BAccountDropdownList");

    // parse profiles and note the active one
    const profiles = JSON.parse(localStorage.getItem("profiles"));
    const activeToken = localStorage.getItem("accessToken");

    // show the active profile name on the toggle button
    const activeProfile = profiles.find(profile => profile.accessToken === activeToken);
    if (activeProfile) {
        accountToggleText.textContent = activeProfile.name;
    }

    // build the account list as one HTML string, filtered by an optional search term
    function renderAccountList(term = "") {
        const query = term.trim().toLowerCase();

        // narrow to profiles matching the search term
        let matches = profiles;
        if (query) {
            matches = profiles.filter(profile => profile.name.toLowerCase().includes(query));
        }

        // empty state when nothing matches
        if (matches.length === 0) {
            accountList.innerHTML = `<li class="headerB2BAccountDropdownListEmpty">No accounts found</li>`;
            return;
        }

        // mark the active profile so it reads as selected
        let html = "";
        matches.forEach(profile => {
            let activeClass = "";
            if (profile.accessToken === activeToken) {
                activeClass = " active";
            }
            html += `<li class="headerB2BAccountDropdownListItem${activeClass}" role="option" data-token="${profile.accessToken}">${profile.name}</li>`;
        });
        accountList.innerHTML = html;
    }

    // open the dropdown: reset the search, render the full list, focus the input
    function openAccountDropdown() {
        accountDropdown.classList.add("active");
        accountToggle.setAttribute("aria-expanded", "true");
        accountSearch.value = "";
        renderAccountList();
        accountSearch.focus();
    }

    // close the dropdown
    function closeAccountDropdown() {
        accountDropdown.classList.remove("active");
        accountToggle.setAttribute("aria-expanded", "false");
    }

    // initial render so the list is ready before the first open
    renderAccountList();

    // toggle the dropdown on button click
    accountToggle.addEventListener("click", function () {
        if (accountDropdown.classList.contains("active")) {
            closeAccountDropdown();
            return;
        }
        openAccountDropdown();
    });

    // filter the list as the user types
    accountSearch.addEventListener("input", function () {
        renderAccountList(this.value);
    });

    // select an account via a single delegated click on the list
    accountList.addEventListener("click", async function (event) {
        const item = event.target.closest(".headerB2BAccountDropdownListItem");
        if (!item) {
            return;
        }

        // save the chosen access token and re-authenticate via multipass
        localStorage.setItem("accessToken", item.dataset.token);
        closeAccountDropdown();
        await b2b.loginViaMultipass();
    });

    // close the dropdown on any outside click
    document.addEventListener("click", function (event) {
        if (!event.target.closest("#headerB2BAccount")) {
            closeAccountDropdown();
        }
    });
}

/**************************
 Header/Announcement Height
 ***************************/
// on load update the top of the header bar for desktop sticky
const header = document.querySelector('#shopify-section-theme-header');
const announcement = document.querySelector('#shopify-section-theme-announcement-secondary');

// listen for screen changes and update the top attribute
const resizeObserver = new ResizeObserver(entries => {
    for (let entry of entries) {
        if (window.innerWidth < 801) {
            header.style.top = `auto`
            return;
        }
        const newHeight = entry.contentRect.height;
        header.style.top = `${newHeight}px`
    }
});
resizeObserver.observe(announcement);

/**************
 Mobile Nav
 ***************/

// mobile slider nested dropdown
document.querySelectorAll(".sliderNavDropdownToggle").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("#slider").classList.add("active");
    document.querySelector('#sliderContent').classList.add('active');
    document.querySelector("body").classList.add("noScroll");
}

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector('#sliderContent').classList.remove('active');
    document.querySelector("#slider").classList.remove("active");
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
async function closeNav() {
    document.querySelector("#slider").close();
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#slider"));